import React from "react";
import {View, StyleSheet} from "react-native";

export default function PtTab(props:any) {
  return (
    <View style={[styles.tabContentWrapper]}>{props.children}</View>
  )
}

const styles = StyleSheet.create({
  tabContentWrapper: {
    position: 'relative'
  },
})
